import { Row, styled } from '@streem/ui-react';
import { useGlobalStore } from '../../../hooks/use_global_context';
import { MediaGallery } from '../../media_gallery/media_gallery';
import { CollapsibleContent } from './collapsible_content';

interface CallDetailMediaGalleryProps {
    readOnly?: boolean;
}

export const CallDetailMediaGallery = ({ readOnly }: CallDetailMediaGalleryProps): JSX.Element => {
    const { configStore, companySettingsStore } = useGlobalStore();

    const videoPreviewEnabled = configStore.videoTrackPreviewEnabled;
    if (!companySettingsStore.editorNotesEnabled) return null;

    return (
        <Section>
            <CollapsibleContent
                title="Media"
                id="post-call-details-media-gallery"
                initialExpandedYn
            >
                <CallDetailWrapper>
                    <MediaGallery readOnly={readOnly} videoPreviewEnabled={videoPreviewEnabled} />
                </CallDetailWrapper>
            </CollapsibleContent>
        </Section>
    );
};

const CallDetailWrapper = styled(Row)({
    columnGap: '2rem',
    margin: '1rem',
});

const Section = styled('section')({
    margin: '1.5rem 0 1.5rem 0',
});
